const state = {
    apiUrl: '',
    signId: '',
    puPredcislo: '',
    puCislo: '',
    puKbanky: '',
    creditAccountIban: '',
    creditAccountName: '',
    creditAccountBic: '',
    suma: '',
    mena: '',
    vs: '',
    ss: '',
    endToEndId: '',
    recipientMessage1: '',
    recipientMessage2: '',
    recipientMessage3: '',
    recipientMessage4: '',
    url: '',
    param: '',
    sign1: '',
    language: '',
    emailNotification: '',
    emailAddress: '',
    id: '',
    isSepa: '',
    sid: '',
    mTokenRefresh: null,
    refreshToken: null,
    invalidated: false,
    signing: false,
    leaveInProcess: false,
    errorId: null,
};

const mutations = {
    setOne: (state, {key, value}) => {
        state[key] = value;
    },
};

const actions = {
    setOne: ({commit}, pair) => {
        commit('setOne', pair);
    },
    setStoreParams: ({commit}, paramObj) => {
        commit('setOne', { key: 'puPredcislo', value: paramObj.pu_predcislo || '' });
        commit('setOne', { key: 'puCislo', value: paramObj.pu_cislo || '' });
        commit('setOne', { key: 'puKbanky', value: paramObj.pu_kbanky || '' });
        commit('setOne', { key: 'suma', value: paramObj.suma || '' });
        commit('setOne', { key: 'mena', value: paramObj.mena || '' });
        commit('setOne', { key: 'vs', value: paramObj.vs || '' });
        commit('setOne', { key: 'ss', value: paramObj.ss || '' });
        commit('setOne', { key: 'endToEndId', value: paramObj.endToEndId || '' });
        commit('setOne', { key: 'creditAccountIban', value: paramObj.creditAccountIban || '' });
        commit('setOne', { key: 'creditAccountName', value: paramObj.creditAccountName || '' });
        commit('setOne', { key: 'creditAccountBic', value: paramObj.creditAccountBic || ''  });
        commit('setOne', { key: 'recipientMessage1', value: paramObj.recipientMessage1 || '' });
        commit('setOne', { key: 'recipientMessage2', value: paramObj.recipientMessage2 || '' });
        commit('setOne', { key: 'recipientMessage3', value: paramObj.recipientMessage3 || '' });
        commit('setOne', { key: 'recipientMessage4', value: paramObj.recipientMessage4 || '' });
        commit('setOne', { key: 'url', value: paramObj.url || '' });
        commit('setOne', { key: 'param', value: paramObj.param || '' });
        commit('setOne', { key: 'sign1', value: paramObj.sign1 || '' });
        commit('setOne', { key: 'emailNotification', value: paramObj.emailNotification || '' });
        commit('setOne', { key: 'emailAddress', value: paramObj.emailAddress || '' });
    }
};

const getters = {
    getOne: state => name => state[name],

    getRecipientMessages: state => {
        return {
            recipientMessage1: state.recipientMessage1,
            recipientMessage2: state.recipientMessage2,
            recipientMessage3: state.recipientMessage3,
            recipientMessage4: state.recipientMessage4
        }
    },
    getStoreParams: state => {
        return {
            apiUrl: state.apiUrl,
            puPredcislo: state.puPredcislo,
            puCislo: state.puCislo,
            puKbanky: state.puKbanky,
            creditAccountIban: state.creditAccountIban,
            creditAccountName: state.creditAccountName,
            creditAccountBic: state.creditAccountBic,
            suma: state.suma,
            mena: state.mena,
            vs: state.vs,
            ss: state.ss,
            endToEndId: state.endToEndId,
            recipientMessage1: state.recipientMessage1,
            recipientMessage2: state.recipientMessage2,
            recipientMessage3: state.recipientMessage3,
            recipientMessage4: state.recipientMessage4,
            url: state.url,
            param: state.param,
            sign1: state.sign1,
            language: state.language,
            emailNotification: state.emailNotification,
            emailAddress: state.emailAddress,
        };
    }
};

export default {
    namespaced: false,
    state,
    mutations,
    actions,
    getters,
}
